module.exports = __webpack_public_path__ + "static/media/JSNMC1.6b82791b.png";